<template>
    <div class="content">
        <div class="row">
            <div class="col-md-12">
                <a-card>
                    <form @submit.prevent="addData($event)">
                        <div class="row">

                            <a-divider orientation="left">اطلاعات کلی </a-divider>
                            <div class="row">
                                <div class="col-md-3 my-1">
                                    <div class="form-group ">
                                        <label>عنوان</label>
                                        <input type="text" name="title" class="form-control" />
                                    </div>
                                </div>
                                <div class="col-md-3 my-1">
                                    <div class="form-group ">
                                        <label class="sr-only" for="inline-form-input-name">
                                            دسته بندی</label>
                                        <a-select @change="getSpecifications()" v-model="info.category_id"
                                             mode="single" style="width:100%"
                                            placeholder="انتخاب دسته بندی ">
                                            <a-select-option v-for="cat in cats" :key="cat.id"
                                                :value="cat.id">
                                                {{ cat . title }}
                                            </a-select-option>
                                        </a-select>
                                    </div>
                                </div>
                                <div class="col-md-3 my-1">
                                    <div class="form-group ">
                                        <label class="sr-only" for="inline-form-input-name">
                                            واحد</label>
                                        <a-select v-model="info.unit_id" mode="single" style="width:100%"
                                            placeholder="انتخاب واحد  ">
                                            <a-select-option v-for="unit in units" :key="unit.id"
                                                :value="unit.id">
                                                {{ '' + unit . name + ' ( x  ' + unit . count + ')' }}
                                            </a-select-option>
                                        </a-select>
                                    </div>
                                </div>
                                <div class="col-md-3 my-1">
                                    <div class="form-group ">
                                        <label class="sr-only" for="inline-form-input-name">
                                            منطقه فروش</label>
                                        <a-tree-select v-model="info.area_id" show-search style="width: 100%"
                                            :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                                            placeholder="انتخاب استان و شهر و منطقه " allow-clear
                                            tree-default-expand-all>
                                            <a-icon slot="suffixIcon" type="smile" />
                                            <a-tree-select-node v-for="state in states" :key="'state' + state.id" :disabled="true"
                                                :value="'state' + state.id" :title="state.name">
                                                <a-tree-select-node v-for="city in state.cities" :key="'city' + city.id" :disabled="true"
                                                    :value="'city' + city.id" :title="city.name">
                                                    <a-tree-select-node v-for="area in city.areas"
                                                        :key="'area' + area.id" :value="'area' + area.id"
                                                        :title="area.name" />

                                                </a-tree-select-node>

                                            </a-tree-select-node>


                                        </a-tree-select>
                                    </div>
                                </div>
                                <div class="col-md-3 ">
                                    <div class="form-group">
                                        <label style="margin-bottom:10px;">تاریخ انقضا </label>
                                        <date-picker v-model="info.expired_date"></date-picker>

                                    </div>
                                </div>
                                <div class="col-md-3 my-1">
                                    <div class="form-group ">
                                        <label> موجودی محصول /تعداد</label>
                                        <input name="stock_count" :disabled="number2 > 0" type="number"
                                            class="form-control" />
                                    </div>
                                </div>
                                <div class="col-md-3 my-1">
                                 <UserSearch @ids="getIds" />
                                </div>
                            </div>

                            <a-divider orientation="left">

                                اطلاعات قیمت (ریال) </a-divider>
                            <div class="row">
                                <div class="col-md-3 my-1">
                                    <div class="form-group ">
                                        <label>قیمت اصلی</label>
                                        <a-input-number v-model="info.cost" class="form-control" :default-value="0"
                                        :disabled="number2 > 0"
                                            :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                                            :parser="value => value.replace(/\$\s?|(,*)/g, '')" />
                                    </div>
                                </div>
                                <div class="col-md-3 my-1">
                                    <div class="form-group ">
                                        <label>قیمت با تخفیف</label>
                                        <a-input-number v-model="info.discounted_cost"  class="form-control"
                                        :disabled="number2 > 0"
                                            :default-value="0"
                                            :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                                            :parser="value => value.replace(/\$\s?|(,*)/g, '')" />
                                    </div>
                                </div>
                                <div class="col-md-3 my-1">
                                    <div class="form-group ">
                                        <label>مقدار نقدی</label>
                                        <a-input-number v-model="info.cash"  class="form-control" :default-value="0"
                                        :disabled="number2 > 0"
                                            :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                                            :parser="value => value.replace(/\$\s?|(,*)/g, '')" />
                                    </div>
                                </div>
                                <div class="col-md-3 my-1">
                                    <div class="form-group ">
                                        <label>مقدار تهاتری</label>
                                        <a-input-number  v-model="info.barter" class="form-control" :default-value="0"
                                        :disabled="number2 > 0"
                                            :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                                            :parser="value => value.replace(/\$\s?|(,*)/g, '')" />
                                    </div>
                                </div>
                            </div>
                            <a-divider orientation="left">عکس و توضیحات</a-divider>
                            <div class=" m-2">
                                <a-upload action="https://api.aatcart.com/uploadImageProduct" list-type="picture"
                                    :default-file-list="fileList" class="upload-list-inline" @change="handleChange">
                                    <a-button>
                                        <a-icon type="upload" /> آپلود عکس
                                    </a-button>
                                </a-upload>
                            </div>
                            <div class="col-md-12 mt-1">
                                <div class="form-group">
                                    <b-form-textarea name="description" id="textarea" v-model="info.description"
                                        placeholder="توضیحات ..." rows="3" max-rows="6"></b-form-textarea>
                                </div>
                            </div>
                            <a-divider orientation="left">مشخصات محصول </a-divider>
                            <span class="text-danger text-center" v-if="info.category_id == undefined">لطفا دسته بندی
                                محصول را انتخاب کنید</span>
                            <div class="p-md-5 table-responsive" v-else>
                                <span class="text-danger text-center" v-if="specifications.length == 0"
                                >  
                                   کاربر گرامی ، دسته بندی انتخاب شده فاقد مشخصه است.</span>
                                <table v-else class="table table-stripped table-bordered table-hover ">
                                    <thead>
                                        <tr>
                                            <th scope="col">نام مشخصه</th>
                                            <th scope="col">مقادیر مشخصه</th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="parent,index in specifications">
                                            <td scope="col">{{ parent . title }}</td>
                                            <td class="d-flex" scope="col">
                                                <a-checkbox @click="selectSp(parent.id,val.id)" :value="val.id"
                                                    v-for="val in parent.values">
                                                    {{ val . title }}
                                                </a-checkbox>
                                            </td>
                                        </tr>
                                    </tbody>

                                </table>
                            </div>


                            <a-divider orientation="left">متغیر های محصول </a-divider>
                            <span class="text-danger text-center" v-if="info.category_id == undefined">لطفا دسته بندی
                                محصول را انتخاب کنید</span>
                            <div v-else>
                                <span class="text-danger text-center p-md-5" v-if="specifications.length == 0"
                                >  
                                   کاربر گرامی ، دسته بندی انتخاب شده فاقد مشخصه است.</span>
                                   <div v-else>
                                    <a-card  :title="'متغیر' + index" :bordered="false" style="width: 100%"
                                    v-for="index in number2">
                                    <input type="hidden" name="product_variables[]" :value="index">
                                    <div class="row">
                                        <div class="col-md-1 ">
                                            <picture-input ref="pictureInput" width="500" height="1150"
                                                margin="16" accept="image/jpeg,image/png" size="5"
                                                radius="5" :crop="false" :alertOnError="false"
                                                button-class="btn btn-success" @change="onChange(index)"
                                                :custom-strings="{
                                                    upload: '<p>دستگاه شما از آپلود عکس پشتیبانی نمی کند</p>',
                                                    drag: ' انتخاب عکس',
                                                    tap: ' انتخاب عکس  ',
                                                    change: 'انتخاب ',
                                                    remove: 'حذف عکس',
                                                    select: 'انتخاب عکس',
                                                    selected: '<p>عکس با موفقیت انتخاب شد</p>',
                                                    fileSize: 'سایز فایل شما زیاد است',
                                                    fileType: 'نوع فایل نا معتبر میباشد',
                                                    aspect: 'Landscape/Portrait',
                                                }"
                                                :id="'product_variable_image' + index">
                                            </picture-input>
                                        </div>
                                        <div class="col-md-11">
                                            <div class="row">
                                                <div class="col-md-3 my-1">
                                                    <div class="form-group ">
                                                        <label class="sr-only" for="inline-form-input-name">
                                                            انتخاب مشخصه</label>
                                                        <select v-model="product_variables_parents[index]"
                                                            name="product_variables_parents[]" class="form-control"
                                                            placeholder="انتخاب  مشخصه ">
                                                            <option v-for="parent in specifications"
                                                                :key="parent.id" :value="parent.id">
                                                                {{ parent . title }}
                                                            </option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div class="col-md-3 my-1">
                                                    <div class="form-group ">
                                                        <label class="sr-only" for="inline-form-input-name">
                                                            انتخاب مقدار</label>
                                                        <select class="form-control" name="product_variables_values[]"
                                                            placeholder="انتخاب مقدار  ">
                                                            <option v-for="child in product_variables_values[index]"
                                                                :key="child.id" :value="child.id">
                                                                {{ child . title }}
                                                            </option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div class="col-md-3 my-1">
                                                    <div class="form-group ">
                                                        <label>قیمت اصلی</label>
                                                        <a-input-number name="product_variables_cost[]"
                                                            class="form-control" :default-value="0"
                                                            :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                                                            :parser="value => value.replace(/\$\s?|(,*)/g, '')" />
                                                    </div>
                                                </div>
                                                <div class="col-md-3 my-1">
                                                    <div class="form-group ">
                                                        <label>قیمت با تخفیف</label>
                                                        <a-input-number name="product_variables_discounted_cost[]"
                                                            class="form-control" :default-value="0"
                                                            :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                                                            :parser="value => value.replace(/\$\s?|(,*)/g, '')" />
                                                    </div>
                                                </div>
                                                <div class="col-md-3 my-1">
                                                    <div class="form-group ">
                                                        <label>مقدار نقدی</label>
                                                        <a-input-number name="product_variables_cash[]"
                                                            class="form-control" :default-value="0"
                                                            :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                                                            :parser="value => value.replace(/\$\s?|(,*)/g, '')" />
                                                    </div>
                                                </div>
                                                <div class="col-md-3 my-1">
                                                    <div class="form-group ">
                                                        <label>مقدار تهاتری</label>
                                                        <a-input-number name="product_variables_barter[]"
                                                            class="form-control" :default-value="0"
                                                            :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                                                            :parser="value => value.replace(/\$\s?|(,*)/g, '')" />
                                                    </div>
                                                </div>
                                                <div class="col-md-3 my-1">
                                                    <div class="form-group ">
                                                        <label>موجودی متغیر</label>
                                                        <input name="product_variables_stock[]" type="text"
                                                            class="form-control" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </a-card>
                                <div style="margin-right: 6%;">
                                    <a-button @click="number2++" type="primary" shape="circle" icon="plus" />
                                    <a-button @click="number2--" type="danger" shape="circle" icon="minus" />

                                </div>
                                   </div>
                                
                            </div>


                            <a-divider orientation="left"> انتخاب از روی نقشه </a-divider>
                            <Map @input="getLocation" />
                        </div>
                        <div class="card-footer  ">
                            <div class="row mt-3 ">
                                <div class="col-md-10"></div>
                                <div class="col-md-1 ">
                                    <button type="submit" class="btn btn-fill btn-outline-success w-100">
                                        ذخیره
                                    </button>
                                </div>

                                <div class="col-md-1 ">
                                    <router-link to="/users/list" class="btn btn-fill btn-outline-danger w-100">بازگشت
                                    </router-link>
                                </div>

                            </div>

                        </div>
                    </form>
                </a-card>
            </div>
        </div>
    </div>
</template>

<script>
    import Map from '../../components/Blocks/ChooseMap.vue';
    import PictureInput from 'vue-picture-input';
    import UserSearch from "../../components/Blocks/UserSelectSingle.vue"

    export default {
        components: {
            Map,
            PictureInput,
            UserSearch
        },

        data() {
            return {
                number: 0,
                number2: 0,
                fileList: [],
                users: [],
                info: {
                    cost:0,
                    discounted_cost:0,
                    cash:0,
                    barter:0,
                    expired_date:''
                },
                cats: [],
                units: [],
                states: [],
                value: undefined,
                location: {
                    lat: '',
                    lng: ''
                },
                images: [],
                product_variables_images: [],
                specifications: [],
                selected_specifications: [],
                product_variables_parents: [],
                product_variables_values: []

            };
        },
        mounted() {
            this.getCats();
            this.getUnits();
            this.getStates();
        },
        methods: {
            onChange(index) {
                let _this = this;
                let formData = new FormData();
                formData.append("file", document.getElementById('product_variable_image' + index).files[0]);
                axios.post("/uploadImageProduct", formData, {
                        headers: {
                            "Content-Type": "multipart/form-data"
                        }
                    }).then(function(response) {
                        _this.product_variables_images.push(response.data.id)
                        _this.$toast.success("عکس  با موفقیت ذخیره شد.   ");
                    })
                    .catch(function(err) {
                        _this.$toast.error("عکس ارسالی  صحیح  نیست.   ");
                        _this.$root.handleAxiosError(err);
                    });
            },
            getLocation(value) {
                this.location.lat = value.position.lat
                this.location.lng = value.position.lng
            },
            async getCats() {
                let _this = this;
                let url = '/categories/all';
                await axios
                    .get(url)
                    .then(function(response) {
                        _this.cats = response.data.data;
                    })
                    .catch(function(err) {
                        _this.$root.handleAxiosError(err);
                    });
            },
            async getSpecifications() {

                let _this = this;
                var url = `/specifications/all?category_id=${this.info.category_id}`;
                await axios
                    .get(url)
                    .then(function(response) {
                        _this.specifications = response.data.data;
                    })
                    .catch(function(err) {
                        _this.$root.handleAxiosError(err);
                    });
            },
            async getUnits() {
                let _this = this;
                let url = '/units/all';
                await axios
                    .get(url)
                    .then(function(response) {
                        _this.units = response.data.data;
                    })
                    .catch(function(err) {
                        _this.$root.handleAxiosError(err);
                    });
            },
            async getStates() {
                let _this = this;
                let url = '/products/states';
                await axios
                    .get(url)
                    .then(function(response) {
                        _this.states = response.data.data;
                    })
                    .catch(function(err) {
                        _this.$root.handleAxiosError(err);
                    });
            },
            handleChange(info) {

                if (info.file.status === 'uploading') {
                    this.loading = true;
                    return;
                }
                if (info.file.status === 'done') {
                    this.images.push(info.file.response.id)
                    getBase64(info.file.originFileObj, imageUrl => {
                        this.imageUrl = imageUrl;
                        this.loading = false;
                    });
                }
            },

            addData(event) {
                let _this = this;
                let data = new FormData(event.target);
                data.append("images", this.images);
                data.append("category_id", this.info.category_id);
                data.append("unit_id", this.info.unit_id);
                                if(this.info.area_id != undefined){

                data.append("area_id", this.info.area_id.replace('area', ''));
                                }
                data.append("product_specifications", JSON.stringify(this.selected_specifications));
                data.append("product_variables_images", this.product_variables_images);
                data.append("expired_date", this.info.expired_date);
                data.append("cost", this.$root.perisan2latin(this.info.cost));
                data.append("discounted_cost", this.$root.perisan2latin(this.info.discounted_cost));
                data.append("barter", this.$root.perisan2latin(this.info.barter));
                data.append("cash", this.$root.perisan2latin(this.info.cash));
                data.append("lat", this.location.lat);
                data.append("lng", this.location.lng);
                if(this.info.seller_id != undefined){
                data.append("seller_id", this.info.seller_id);

                }
                _this.$root.loading = true;
                axios
                    .post("/products/add", data)
                    .then(function(response) {
                        _this.$root.loading = false;
                        _this.$toast.success("محصول با موفقیت ذخیره شد");
                        _this.$router.push("/products/list");
                    })
                    .catch(function(err) {
                        _this.$root.loading = false;
                        _this.$root.handleAxiosError(err);
                    });
            },
            selectSp(parent, value) {
                var map = {};
                map[parent] = value
                this.selected_specifications.push(map);
            },
            getIds(value) {
                this.info.seller_id=value
            },
        },
        watch: {
            specifications_parents() {
                let index = this.specifications_parents.length - 1;
                const item = this.specifications.find(({
                    id
                }) => id === this.specifications_parents[index]);
                this.specifications_values[index] = item.values;
            },
            product_variables_parents() {
                let index = this.product_variables_parents.length - 1;
                const item = this.specifications.find(({
                    id
                }) => id === this.product_variables_parents[index]);
                this.product_variables_values[index] = item.values;
            }
        }
    };
</script>
<style scoped>
    /* tile uploaded pictures */
    .upload-list-inline>>>.ant-upload-list-item {
        float: left;
        width: 200px;
        margin-right: 8px;
    }

    .upload-list-inline>>>.ant-upload-animate-enter {
        animation-name: uploadAnimateInlineIn;
    }

    .upload-list-inline>>>.ant-upload-animate-leave {
        animation-name: uploadAnimateInlineOut;
    }

    .avatar-uploader>.ant-upload {
        width: 128px;
        height: 128px;
    }

    .ant-upload-select-picture-card i {
        font-size: 32px;
        color: #999;
    }

    .ant-upload-select-picture-card .ant-upload-text {
        margin-top: 8px;
        color: #666;
    }
</style>
